var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$temAcessoView('REL-PAGMEN-00'))?_c('b-list-group-item',{staticClass:"lista-menu",on:{"click":function($event){$event.stopPropagation();return _vm.abrirPainel()}}},[_c('span',[_vm._v("PAGAMENTOS MENSAIS")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }